/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';

import classNames from 'classnames';

import classes from './styles.module.scss';
import volumeIcon from '../../../../../assets/images/create-meeting/volume.svg';

export default function Mute({ videoRef }) {
  const [isMuted, setIsMuted] = useState(false);

  const toggleMute = () => {
    if (!videoRef.current) {
      return;
    }

    videoRef.current.muted = !isMuted;
  };

  useEffect(() => {
    const currentVideo = videoRef.current;
    const volumeChangeHandler = () => {
      setIsMuted(currentVideo?.muted);
    };

    if (currentVideo) {
      currentVideo.addEventListener('volumechange', volumeChangeHandler);
    }

    return () => {
      if (currentVideo) {
        currentVideo.removeEventListener('volumechange', volumeChangeHandler);
      }
    };
  }, [videoRef]);

  return (
    <button
      type="button"
      className={classNames(classes.Mute, {
        [classes.muted]: isMuted,
      })}
      onClick={toggleMute}
    >
      <img src={volumeIcon} alt="Mute" />
    </button>
  );
}
